import styles from "./ServicesSection.module.scss";
import {useTranslation} from "react-i18next";
import useAppSelector from "../../../hooks/useAppSelector";
import {useEffect, useState} from "react";
import {IPublicTrainingCourse} from "../../../models/TrainingCourse";
import SectionTitle from "../../../components/UI/SectionTitle/SectionTitle";
import SectionSubtitle from "../../../components/UI/SectionSubtitle/SectionSubtitle";
import {getImageFromAuthServer} from "../../../helpers/image.helper";
import {Link, useNavigate} from "react-router-dom";
import arrowRight from "../../../assets/images/icons/arrow-right-3.svg";
import {textCropping} from "../../../helpers/language.helper";
import ServiceModal from "../../ServicesPage/ServiceModal/ServiceModal";

const ServicesSection = () => {

    const {t} = useTranslation();

    const {content} = useAppSelector(state => state.siteContentSlice);
    const {classes} = useAppSelector(state => state.classesSlice);

    const [selectedServiceItem, setSelectedServiceItem] = useState<IPublicTrainingCourse | null>(null)
    const [filteredServices, setFilteredServices] = useState<IPublicTrainingCourse[]>([]);

    useEffect(() => {
        if (content.servicesItems && classes.length) {
            const settings = JSON.parse(content.servicesItems);
            const customSort = (a: any, b: any) => {
                const indexA = settings.order.indexOf(a.id);
                const indexB = settings.order.indexOf(b.id);
                return indexA - indexB;
            };
            const filteredAndSortedServices = classes.filter(el => settings.selectedItems.includes(el.id)).sort(customSort);
            setFilteredServices(filteredAndSortedServices);
        }
    }, [classes]);

    const clickOnServiceItem = (el: IPublicTrainingCourse) => {
        setSelectedServiceItem(el);
    }

    const closeServiceModal = () => {
        setSelectedServiceItem(null);
    }

    const renderWrapper = (length: number) => {
        if (length === 3) {
            return (
                <div className={`${styles.commonWrapper} ${styles.wrapper3}`}>
                    {filteredServices.map(el => {
                        return (
                            <div
                                onClick={() => clickOnServiceItem(el)}
                                className={styles.item}
                                style={{backgroundImage: `url(${getImageFromAuthServer(el.image)})`}}>
                                <div className={styles.content}>
                                    <h4 className={styles.title}>{el.name}</h4>
                                    <p className={styles.description}>{textCropping(el.description, 150)}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            )
        } else if (length === 2) {
            return (
                <div className={`${styles.commonWrapper} ${styles.wrapper2}`}>
                    {filteredServices.map(el => {
                        return (
                            <div
                                onClick={() => clickOnServiceItem(el)}
                                className={styles.item}
                                style={{backgroundImage: `url(${getImageFromAuthServer(el.image)})`}}>
                                <div className={styles.content}>
                                    <h4 className={styles.title}>{el.name}</h4>
                                    <p className={styles.description}>{textCropping(el.description, 200)}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            )
        } else if (length === 1) {
            return (
                <div className={`${styles.commonWrapper} ${styles.wrapper1}`}>
                    {filteredServices.map(el => {
                        return (
                            <div
                                onClick={() => clickOnServiceItem(el)}
                                className={styles.item}
                                style={{backgroundImage: `url(${getImageFromAuthServer(el.image)})`}}>
                                <div className={styles.content}>
                                    <h4 className={styles.title}>{el.name}</h4>
                                    <p className={styles.description}>{textCropping(el.description, 200)}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            )
        }
    }

    return (
        <section className={`${styles.section} ${filteredServices.length && styles.length1}`}>
            <div className={"container"}>
                <SectionTitle text={t("Services")}/>
                <SectionSubtitle text={content.servicesDescription}/>
                {renderWrapper(filteredServices.length)}
                <div className={styles.linkWrapper}>
                    <Link className={styles.link} to={"/services"}>{t("SeeAllServices")}<img src={arrowRight}
                                                                                             alt={"move"}/></Link>
                </div>
            </div>
            {
                selectedServiceItem && (
                    <ServiceModal
                        item={selectedServiceItem}
                        closeModalFn={closeServiceModal}
                    />
                )
            }

        </section>
    )
}

export default ServicesSection;